/**
 * @generated SignedSource<<7b8a33563d39a2d5ff3df2e44ed9459b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type BookScrapsDeleteInput = {
  book: string;
  bookScraps: ReadonlyArray<string>;
};
export type BookId_bookScrapsDeleteMutation$variables = {
  input: BookScrapsDeleteInput;
};
export type BookId_bookScrapsDeleteMutation$data = {
  readonly bookScrapsDelete: {
    readonly id: string;
    readonly unclassifiedBookScrapCount: number;
  };
};
export type BookId_bookScrapsDeleteMutation = {
  response: BookId_bookScrapsDeleteMutation$data;
  variables: BookId_bookScrapsDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "Book",
    "kind": "LinkedField",
    "name": "bookScrapsDelete",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "unclassifiedBookScrapCount",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "BookId_bookScrapsDeleteMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "BookId_bookScrapsDeleteMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "05e9adfbabe53ab4cd2a4830e0d4f8e5",
    "id": null,
    "metadata": {},
    "name": "BookId_bookScrapsDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation BookId_bookScrapsDeleteMutation(\n  $input: BookScrapsDeleteInput!\n) {\n  bookScrapsDelete(input: $input) {\n    id\n    unclassifiedBookScrapCount\n  }\n}\n"
  }
};
})();

(node as any).hash = "db98d1d8f659bf9eb225c05c3facf6d3";

export default node;
